var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTesla(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "255px",
    height: "253px",
    viewBox: "0 0 255.0 253.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.5,0 L115.647,31.848 L141.793,0.005 C141.793,0.005 185.759306,0.9194333 229.958601,21.0112677 L231.298,21.626 C219.857,38.804 197.173,47.262 197.173,47.262 C195.633,32.127 184.967,28.419 151.152,28.419 L115.676,227.938 L79.914,28.39 C46.326,28.414 35.673,32.122 34.124,47.258 C34.124,47.258 11.431,38.8 0,21.622 C44.64,0.934 89.5,0 89.5,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.787,0 C164.066,0.157 207.357,6.416 253.584,24.705 C253.584,24.705 252.131,29.201 246.479,39.374 C204.191,20.943 162.882,15.084 126.792,15.36 C90.696,15.084 49.38,20.943 7.1,39.374 C2.21701538,30.5239538 0.129709822,25.0492017 0.00588319345,24.7206726 L0,24.705 C46.221,6.417 89.51,0.157 126.787,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5439999999999827 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.129999999999995 24.563999999999965)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 231.298,0 231.298,227.938 0,227.938 0,0",
    stroke: "none",
    fill: "#9F29FF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 253.584,0 253.584,39.374 0,39.374 0,0",
    stroke: "none",
    fill: "#9F29FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesla);
export default __webpack_public_path__ + "static/media/tesla.8b809bcfce26554490d0414c1c1c71d4.svg";
export { ForwardRef as ReactComponent };